
import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { imageatch_detData } from '../../../../../@core/interfaces/masters/imageatch_det';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'ngx-printer-footer',
  templateUrl: './printer-footer.component.html',
  styleUrls: ['./printer-footer.component.scss']
})
export class PrinterFooterComponent implements OnInit {


  @Input() psDetails;
  @Input() srcname;
  @Input() srcname2;
  @Input() title;


  
  @Input() type: any;
  @Input() id: any;
  @Input() name: any;
  @Input() isSign:boolean=false;

  get apiUrl(): string {
    return environment.apiUrl;
  }

  private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
  protected readonly unsubscribe$ = new Subject<void>();
  
  constructor(private iatchSrvc: imageatch_detData) { }

  ngOnInit(): void {
    
  }
  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    //console.log("Page footer =",this.type,"=",this.id,"-",this.name);
  }
  ngOnChanges(changes: any): void { 
    var data=localStorage.getItem("EHR_Doctor_logo");
    if(!!data){
      this.srcname=data;
    }
    if(!!this.psDetails?.bottomFooterlogoCategory)
      this.onLogoChange([{value:this.psDetails?.bottomFooterlogoCategory}],'logo1')
    if(!!this.psDetails?.bottomFooter_2_logoCategory)
      this.onLogoChange([{value:this.psDetails?.bottomFooter_2_logoCategory}],'logo2')
  }
  onLogoChange(event,type){
    var logosrc=this.getlogoLocal(event[0]?.value);
    if(!!logosrc){
        if("logo1"==type)
            this.srcname = logosrc;
        else if("logo2"==type)
            this.srcname2 = logosrc;
    }
    else{
      this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/${event[0]?.value}`).pipe(takeUntil(this.unsubscribe$)).subscribe((datas: any) => {
        var x= datas.filter(x=>x.phyId==null && x.empId==null && x.patId==null&&x.tenantId===this.tenantId && x.category==event[0]?.value);
        if(x.length>0)
        {
          x[0].isCreate = true;
          x[0].isEdit = true;
          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`,x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
            if("logo1"==type){
                this.srcname = 'data:image/jpeg;base64,' + downloaddata;
                this.logoLocalSave(event[0]?.value,this.srcname);
            }
            else if("logo2"==type){
                this.srcname2 = 'data:image/jpeg;base64,' + downloaddata;
                this.logoLocalSave(event[0]?.value,this.srcname2);
            }else{
              this.srcname2='/assets/images/white.png';
            }
          }, (error) => {
            this.srcname2='/assets/images/white.png';
          }, () => {

          });
        }
      },error=>{

      });
    }
  }
  logoLocalSave(name,src){
    localStorage.setItem(name,src);
  }
  getlogoLocal(name){
    return localStorage.getItem(name);
  }
}
